import React from 'react';
import styled, { keyframes } from 'styled-components';
import SubmissionMessageLib, {
  Props as SubmissionMessageComponentProps,
  defaultMessages,
} from 'src/lib/components/Form/SubmissionMessage';

export type Props = SubmissionMessageComponentProps;

const SubmissionMessage: React.FC<Props> = ({ ...props }) => {
  const messages = defaultMessages;
  messages.failure.text = 'Error! Please try again later';
  return (
    <SubmissionMessageOuter>
      <Bg />
      <InnerWrap>
        <SubmissionMessageLib {...props} messages={messages} />
      </InnerWrap>
    </SubmissionMessageOuter>
  );
};
export default SubmissionMessage;

const SubmissionMessageOuter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${keyframes`
    from { opacity: 0 }
    to { opacity: 1 }
  `} 1s both;
  /* .success {
    color: lightgreen;
  } */
`;

const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.9;
  .dark-bg & {
    background-color: ${(p) => p.theme.palette.primary};
  }
`;

const InnerWrap = styled.div`
  position: relative;
  font-weight: bold;
`;
